export class Contact {
    MerchantID: string;
    From: string;
    Subject: string;
    Comments: string;
    Name: string;
    Phone: string;
}